export const getBaseUrl = () => {
  const isDev = process.env.NODE_ENV === 'development';

  // our dev local proxy seems unable to handle more than 1 connection
  if (isDev) return process.env.BACKEND_URL;

  // assume relative url (Cloudflare in production)
  if (process.env.API_PROXY) return '';

  // fallback to backend
  return process.env.BACKEND_URL;
};
